export * from './validVehiclePlate'
